/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createLog } from '../../factoriesAny.js';
export var logDependencies = {
  ComplexDependencies: ComplexDependencies,
  divideScalarDependencies: divideScalarDependencies,
  typedDependencies: typedDependencies,
  createLog: createLog
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLog.generated.js
// module id = 330
// module chunks = 0